import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface CoverageAlertBannerProps {
  message: string;
  actionLabel: string;
  onAction: () => void;
  disabled?: boolean;
  className?: string;
}

export const CoverageAlertBanner = ({
  message,
  actionLabel,
  onAction,
  disabled,
  className,
}: CoverageAlertBannerProps) => (
  <div
    className={cn('rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-800', className)}
  >
    <div className="flex items-center justify-between gap-3">
      <span className="font-medium">{message}</span>
      <Button
        type="button"
        size="sm"
        variant="outline"
        className="shrink-0"
        disabled={disabled}
        onClick={onAction}
      >
        {actionLabel}
      </Button>
    </div>
  </div>
);
